<template>
	<div>
		<el-card>
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="马甲用户">
					<span style="margin-right: 10px;color: #999;">{{userName}}</span>
					<el-button @click="userDialogVisible = true">选择</el-button>
				</el-form-item>
				<el-form-item label="圈子" prop="title">
					<span style="margin-right: 10px;color: #999;">{{topicName}}</span>
					<el-button @click="topicDialogVisible = true">选择</el-button>
				</el-form-item>
				<el-form-item label="人物" prop="title">
					<span style="margin-right: 10px;color: #999;">{{starName}}</span>
					<el-button @click="shijianDialogVisible = true">选择</el-button>
				</el-form-item>
				<el-form-item label="标签" prop="title">
					<el-input type="textarea" v-model="form.tag" placeholder="请输入标签内容"></el-input>
				</el-form-item>
				<el-form-item label="内容" prop="title">
					<el-input type="textarea" v-model="form.content" placeholder="请输入帖子内容"></el-input>
				</el-form-item>
				<el-form-item label="图片">
					<el-upload ref="uUpload" :multiple="true" :headers="headers" class="avatar-uploader"
						list-type="picture-card" :action="action" :on-success="uploadAlbum" :on-remove="onRemove">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">发布
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 选择马甲弹窗 -->
		<el-dialog title="选择马甲" :visible.sync="userDialogVisible" width="70%">
			<el-table ref="multipleTable" :data="userList">
				<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="sex" label="性别"> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column width="200px;">
					<template slot-scope="scope">
						<el-button type="primary" @click="onUser(scope.row.uid,scope.$index)">选择</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
				layout="total,prev,pager,next,jumper" :total="userLength">
			</el-pagination>
		</el-dialog>
		<!-- 选择圈子弹窗 -->
		<el-dialog title="选择圈子" :visible.sync="topicDialogVisible" width="70%">
			<el-table ref="multipleTable" :data="topicList" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="id" label="ID" width="50">
				</el-table-column>
				<el-table-column align="center" label="封面" prop="cover_image">
					<el-image slot-scope="scope" style="width: 80px; height: 80px" :src="scope.row.cover_image">
					</el-image>
				</el-table-column>
				<el-table-column width="100" prop="userInfo.nickname" label="创建者" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="topic_name" label="圈子名称">
				</el-table-column>
				<el-table-column prop="description" label="圈子描述" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" @click="onTopic(scope.row.id,scope.$index)">选择</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="topicPageChange" :current-page="currentPage" :page-size="pagesize"
				layout="total,prev,pager,next" :total="communityLength">
			</el-pagination>
		</el-dialog>
		<!-- 选择事件弹窗 -->
		<el-dialog title="选择事件" :visible.sync="shijianDialogVisible" width="70%">
			<el-table ref="multipleTable" :data="shijianList" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="id" label="ID" width="50">
				</el-table-column>
				<el-table-column align="center" label="封面" prop="image">
					<el-image slot-scope="scope" style="width: 80px; height: 80px" :src="'https://z3.sirleo.cn/'+scope.row.image">
					</el-image>
				</el-table-column>
<!--				<el-table-column width="100" prop="userInfo.nickname" label="创建者" show-overflow-tooltip>-->
<!--				</el-table-column>-->
				<el-table-column prop="star_name" label="事件名称">
				</el-table-column>
				<el-table-column prop="star_info" label="事件描述" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="add_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" @click="onShijian(scope.row.id,scope.$index)">选择</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="topicPageChange" :current-page="currentPage" :page-size="pagesize"
										 layout="total,prev,pager,next" :total="communityLength">
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				topicDialogVisible: false,
				shijianDialogVisible: false,
				userDialogVisible: false,
				action: this.$H.domain + "common/uploadFile",
				headers: {
					token: this.$store.state.userInfo.token
				},
				userName: "请选择马甲",
				topicName: "请选择圈子",
				starName: "请选择人物",
				form: {
					uid: "",
					topic_id: "",
					star_id:"",
					tag:"",
					content: "",
					media: []
				},
				btnLoading: false,
				btnDisabled: false,
				goodsClassList: [],
				currentPage: 1,
				pagesize: 10,
				userList: [],
				userLength: 0,
				// pagesize: 0,
				topicList: [],
				shijianList:[],
				communityLength: 0
			}
		},
		created() {
			this.getUserList();
			this.getTopicList();
			this.getShijianList();
		},
		methods: {
			onSubmit() {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("post/vestPostAdd", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.$refs.uUpload.clearFiles();

						this.form = {
							uid: "",
							topic_id: "",
							star_id:"",
							tag:"",
							content: "",
							media: []
						}
						
						this.userName = "请选择马甲";
						this.topicName = "请选择圈子";
						this.starName = "请选择人物";
						this.$message.success(res.msg)
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getUserList();
			},
			topicPageChange(currentPage){
				this.currentPage = currentPage;
				this.getTopicList();
			},
			onRemove(file, fileList) {
				let album = [];
				fileList.forEach((item, index) => {
					album.push(item.response.data.url)
				})
				this.form.media = album;
			},
			uploadAlbum(e) {
				this.form.media.push(e.result.url);
			},

			getUserList() {
				this.$H
					.get("user/list", {
						page: this.currentPage,
						type: 2
					})
					.then((res) => {
						this.userList = res.result.data;
						this.userLength = res.result.total;
						this.pagesize = res.result.per_page;
					});
			},
			onUser(uid, index) {
				this.form.uid = uid;
				this.userName = this.userList[index].nickname;
				this.userDialogVisible = false;
			},
			onTopic(id, index) {
				this.form.topic_id = id;
				this.topicName = this.topicList[index].topic_name;
				this.topicDialogVisible = false;
			},
			onShijian(id, index) {
				this.form.star_id = id;
				this.starName = this.shijianList[index].stock_name;
				this.shijianDialogVisible = false;
			},
			getTopicList() {
				this.$H
					.get("topic/listAll", {
						page: this.currentPage
					})
					.then((res) => {
						this.topicList = res.result.data;
						this.pagesize = res.result.per_page;
						this.communityLength = res.result.total;
					})
			},
			getShijianList() {
				this.$H
						.get("topic/shijianAll", {
							page: this.currentPage
						})
						.then((res) => {
							this.shijianList = res.result;
							this.pagesize = res.result.per_page;
							this.communityLength = res.result.total;
						})
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 145px;
		height: 145px;
		line-height: 145px;
		text-align: center;
	}

	.avatar {
		width: 145px;
		height: 145px;
		display: block;
	}
</style>
